import { ScreenshotValidationOptions, WopeeOptions } from './config.interface.js';

export { ScreenshotValidationOptions, WopeeOptions };
